// The dashboard is the core plus ONE pack per category. A pack adds pages (routes), menu entries, vocabulary and its own
// onboarding; the account category picks the pack, and its modules (Helper/category.js) switch single pages and entries
// on or off. Adding a category = adding a folder here and listing it below.
import core from "./core";
import school from "./school";
import gym from "./gym";
import { registerMessages, t } from "../Helper/i18n";
import { buildMenuFrom, isAllowed } from "./menus";

const PACKS = { school, gym };

export function packFor(categoryId) {
  return PACKS[categoryId] || null;
}

registerMessages(core.messages);

/** Makes the vocabulary of this category pack the one t() answers with (the core is always there underneath). */
export function activate(categoryId) {
  registerMessages(core.messages);
  const pack = packFor(categoryId);
  if (pack) {
    registerMessages(pack.messages);
  }
}

/** Every route of the core and the pack, whatever the modules (used to tell which pages an account must not reach). */
export function allRoutes(categoryId) {
  const pack = packFor(categoryId);
  return [...core.routes, ...(pack ? pack.routes : [])];
}

/** Core routes + the pack ones, without the ones whose module this account does not have. */
export function buildRoutes(categoryId, modules) {
  const pack = packFor(categoryId);
  return [...core.routes, ...(pack ? pack.routes : [])].filter((r) => isAllowed(r, modules));
}

/** The rail: the core entries plus the entries of the category pack, for the modules the account has. */
export function buildMenu(categoryId, modules) {
  const pack = packFor(categoryId);
  return buildMenuFrom([...core.menu, ...(pack ? pack.menu : [])], modules, t);
}

/** The onboarding page of the pack (null: the category has none yet). */
export function onboardingFor(categoryId) {
  const pack = packFor(categoryId);
  return pack && pack.Onboarding ? pack.Onboarding : null;
}
